import React from 'react';
/**
 * This is simply a button wrapper, adds a div with `role="button"` and a onClick
 */
export var IconButton = function (_a) {
    var onClick = _a.onClick, children = _a.children;
    return (React.createElement("button", { type: "button", "data-testid": "cancel-upload-button", "aria-label": "Cancel upload", className: "rfu-icon-button", onClick: onClick }, children));
};
